export const MOBILE       = "screen and (max-width: 767px)";
export const DESKTOP_DOWN = "screen and (max-width: 1199px)";
